import React from "react";
import { Link } from "react-router-dom";
import PageBanner from "../assets/Images/page-banner.jpg";

// Banner with breadcrumbs. Pass `title` to make it the page's H1; without it
// the organisation name is shown as a styled non-heading (for pages that
// render their own H1 further down, like the Tamil anthem).
const PageHeader = ({ breadcrumbs, title }) => {
  const TitleTag = title ? "h1" : "p";

  return (
    <div
      className="container-fluid banner-bg py-5 px-0 d-flex justify-content-start align-items-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.7)), url(${PageBanner})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container d-flex justify-content-start align-items-center py-5 mt-5">
        <div className="row mt-5">
          <TitleTag className="h1 text-white fw-bold">
            {title || "Western Sydney Tamil Study Centre"}
          </TitleTag>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-start m-0">
              {breadcrumbs.map((breadcrumb, index) => (
                <li
                  key={index}
                  className={`breadcrumb-item heading fs-5 ${
                    breadcrumb.active ? "active text-white" : ""
                  }`}
                  aria-current={breadcrumb.active ? "page" : undefined}
                >
                  {breadcrumb.active ? (
                    breadcrumb.label
                  ) : (
                    <Link
                      to={breadcrumb.href}
                      className="text-light text-decoration-none"
                    >
                      {breadcrumb.icon && (
                        <i className={`bi ${breadcrumb.icon} me-2`}></i>
                      )}
                      {breadcrumb.label}
                    </Link>
                  )}
                </li>
              ))}
            </ol>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
